<template>
  <v-container fluid class="px-10">
    <!-- <div class="get-data" v-on:click="getSharedsForCsv()">hola</div>

    <vue-json-to-csv class="get-data" :json-data="sharedsForCsv">
      Download Data
    </vue-json-to-csv> -->
    <!-- <button @click="fixUsersMaxMXP">Fix Users Max MXP</button> -->
    <p class="text-h6 text--secondary font-weight-bold">Dashboard</p>
    <div class="row">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <v-card class="premium-numbers-container">
          <div class="premium-numbers-header">
            <div class="chart-icon-container">
              <img
                :src="require('@/assets/chart_white.svg')"
                class="chart-icon"
              />
            </div>
            <span class="premium-numbers-title">Total Premium Users</span>
          </div>
          <div class="premium-numbers-data-container">
            <div>
              <div>Today's Premium users:</div>
              <div>
                Compared with
                <date-range-picker
                  v-model="premiumNumbersDate"
                  single-date-picker="single"
                  :auto-apply="true"
                  ref="picker"
                  :min-date="new Date('03-10-2025')"
                  :max-date="new Date()"
                  @update="getPremiumNumbers"
                  control-container-class="test"
                  :ranges="false"
                >
                  <template v-slot:input="picker">
                    <div class="test">
                      {{ getSelectedDate(picker)
                      }}<v-icon
                        style="margin-top: -3px; margin-left: 4px"
                        color="primary"
                        >mdi-calendar-edit</v-icon
                      >
                    </div>
                  </template>
                </date-range-picker>
                <!-- {{ comparisionData.comparedDate.toLocaleDateString() }}: -->
              </div>
            </div>
            <div style="display: flex; gap: 16px">
              <div>
                <div>{{ comparisionData.today.current }}</div>
                <div>{{ comparisionData.compared.current }}</div>
              </div>
              <div>
                <div
                  style="font-weight: bold"
                  :style="
                    comparisionData.difference > 0
                      ? `color:green`
                      : comparisionData.difference < 0
                      ? `color:red`
                      : ``
                  "
                >
                  <img
                    :src="require('@/assets/subs_up.svg')"
                    class="triangle"
                    v-if="comparisionData.difference > 0"
                  />
                  <img
                    :src="require('@/assets/subs_down.svg')"
                    class="triangle triangle-down"
                    v-if="comparisionData.difference < 0"
                  />
                  {{ comparisionData.difference }} |
                  {{ comparisionData.differencePercent.toFixed(2) }}%
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="8" md="6" lg="8" xl="7">
        <trends-card />
      </v-col>
      
    </div>
    <div class="row">
      <div class="col col-7">
        <events-section
          :openErrorModal="openErrorModal"
          :openPostModal="openPostModal"
          :openResultModal="openResultModal"
        />
      </div>
      <div class="col col-5">
        <live-users-table :users.sync="liveUsers" />
      </div>
    </div>
    <error-modal
      :show="showErrorModal"
      :error="errorMessage"
      :close="closeErrorModal"
    />
    <post-detail-modal
      :show="showPostDetail"
      :item="selectedPost"
      :close="closePostModal"
    />
    <result-modal
      :show="showResultDetail"
      :resultId="selectedResult"
      :resultUser="resultUser"
      :resultType="resultType"
      :close="closeResultModal"
    />
  </v-container>
</template>

<script>
import EventRow from "@/components/admin/events/EventRow.vue";
import ErrorModal from "@/components/admin/events/ErrorModal.vue";
import PostDetailModal from "@/components/admin/posts/PostDetailModal.vue";
import ResultModal from "@/components/admin/results/ResultModal.vue";
import DateRangePicker from "vue2-daterange-picker";
//you need to import the CSS manually (in case you want to override it)
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import LiveUsersTable from "@/components/admin/events/LiveUsersTable.vue";
import EventsSection from "@/components/admin/events/EventsSection.vue";
import PremiumSubscribersCard from "@/components/admin/events/PremiumSubscribersCard.vue";
import TrendsCard from "@/components/admin/events/TrendsCard.vue";

export default {
  name: "Dashboard",
  components: {
    EventRow,
    ErrorModal,
    PostDetailModal,
    DateRangePicker,
    ResultModal,
    LiveUsersTable,
    EventsSection,
    PremiumSubscribersCard,
    TrendsCard,
  },
  data: () => ({
    sharedsForCsv: [],
    liveUsers: [],
    showErrorModal: false,
    errorMessage: "",
    showPostDetail: false,
    selectedPost: "",
    showResultDetail: false,
    selectedResult: undefined,
    resultUser: undefined,
    resultType: undefined,
    comparisionData: {
      today: { current: 0 },
      compared: { current: 0 },
      difference: 0,
      differencePercent: 0,
      comparedDate: new Date(),
    },
    premiumNumbersDate: {
      startDate: moment().subtract(1, "day").toDate(),
      endDate: new Date(),
    },
  }),
  created() {
    this.getPremiumNumbers();
  },
  methods: {
    getSharedsForCsv() {
      this.$store
        .dispatch("getSharedsForCsv")
        .then((res) => {
          this.sharedsForCsv = res;
        })
    },
    // fixUsersMaxMXP() {
    //   this.$store
    //     .dispatch("fixMaxMXP")
    //     .then((res) => {
    //       console.log(res);
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // },
    openErrorModal(item) {
      this.errorMessage = item.error;
      this.showErrorModal = true;
    },
    closeErrorModal() {
      this.errorMessage = "";
      this.showErrorModal = false;
    },
    openPostModal(item) {
      this.selectedPost = item.postId;
      this.showPostDetail = true;
    },
    closePostModal() {
      this.selectedPost = undefined;
      this.showPostDetail = false;
    },
    openResultModal(item) {
      this.selectedResult = item.resultId;
      this.resultUser = item.user;
      this.resultType = item.type;
      this.showResultDetail = true;
    },
    closeResultModal() {
      this.selectedResult = undefined;
      this.resultUser = undefined;
      this.resultType = undefined;
      this.showResultDetail = false;
    },
    async getPremiumNumbers(comparedDate) {
      if (comparedDate?.startDate) {
        this.premiumNumbersDate = comparedDate;
      }
      this.$store
        .dispatch("getCurrentPremiums", comparedDate?.startDate)
        .then((res) => {
          this.comparisionData = res;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getSelectedDate(range) {
      if (range.startDate) {
        return range.startDate.toLocaleDateString();
      }
      return new Date().toLocaleDateString();
    },
  },
};
</script>

<style scoped>
.premium-numbers-container {
  display: flex;
  flex-direction: column;
  padding: 16px 16px;
  justify-content: space-between;
  height: 160px;
}
.premium-numbers-data-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.premium-numbers-title {
  font-weight: bold;
  font-size: 18px;
  color: #3a3a3a;
  text-align: left;
}
.triangle {
  height: 10px;
  width: 10px;
}
.chart-icon-container {
  background-color: #ed702d;
  height: 64px;
  width: 64px;
  border-radius: 32px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chart-icon {
  height: 40px;
  width: 40px;
}
.premium-numbers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.test {
  color: #3a3a3a;
  font-weight: bold;
}
.test:hover {
  cursor: pointer;
}
.triangle-down {
  transform: rotate(180deg);
}
</style>